module.exports = __webpack_public_path__ + "img/dummycourses.c3b8ea9f.gif";